import { AfterViewInit, DestroyRef, Directive, Input } from '@angular/core';
import { MatTabGroup } from "@angular/material/tabs";
import { ActivatedRoute, Router } from "@angular/router";

@Directive({
	selector: '[anchorSelectedTab]'
})
export class AnchorSelectedTab implements AfterViewInit {

	@Input('anchorIds') anchorIds: string[] = [];

	constructor(
		private readonly matTabGroup: MatTabGroup,
		private readonly router: Router,
		private readonly activatedRoute: ActivatedRoute,
		private readonly destroyRef: DestroyRef
	) { }

	ngAfterViewInit() {
		const tabChangedSub = this.matTabGroup.selectedTabChange.subscribe(event => {
			this.router.navigate([], {
				relativeTo: this.activatedRoute,
				fragment: this.anchorIds[event.index] ||  event.tab.textLabel.toLowerCase().replace(' ', '_'),
				replaceUrl: true
			});
		});

		this.destroyRef.onDestroy(() => tabChangedSub.unsubscribe());
	}
}
